'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteEditor = exports.default = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _dec, _desc, _value, _class3, _class4, _class5, _temp2, _dec2, _dec3, _dec4, _desc2, _value2, _class6, _descriptor;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseViewstore = require('base-viewstore');

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _simboxEditable = require('simbox-editable');

var _editor = require('simbox-editable/editor');

var _editor2 = _interopRequireDefault(_editor);

var _collectionGridEditor = require('collection-grid-editor');

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

var _layoutComponent = require('layout-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ConfigurationEditor = (0, _simboxEditable.Decorator)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_BaseComponent) {
  (0, _inherits3.default)(ConfigurationEditor, _BaseComponent);

  function ConfigurationEditor() {
    (0, _classCallCheck3.default)(this, ConfigurationEditor);
    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationEditor.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfigurationEditor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          editorViewStore = _props.editorViewStore,
          currentView = _props.currentView,
          contentModel = _props.contentModel,
          _props$contentModel = _props.contentModel,
          isNew = _props$contentModel.isNew,
          slots = _props$contentModel.slots,
          registeredAuthStrategies = _props$contentModel.registeredAuthStrategies,
          warning = _props$contentModel.warning;
      var deleteAllEntities = this.viewStore.deleteAllEntities;


      if (options && options.init) return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          'Welcome to SimGreat.  Please initialize your authoring environment.'
        ),
        !!warning.noAdminRole && _react2.default.createElement(
          'div',
          null,
          warning.noAdminRole,
          (0, _editor.createEditorElement)("roles", slots, contentModel, this.viewStore, { hideInMenu: "edit", noChildren: true, onSave: function onSave() {
              return editorViewStore.stopEditing();
            } })
        ),
        !warning.noAdminRole && !!warning.noAdminRoute && _react2.default.createElement(
          'div',
          null,
          warning.noAdminRoute,
          (0, _editor.createEditorElement)("routes", slots, contentModel, this.viewStore, { registeredAuthStrategies: registeredAuthStrategies, hideInMenu: "edit", noChildren: true, onSave: function onSave() {
              return editorViewStore.stopEditing();
            } })
        ),
        !warning.noAdminRole && !warning.noAdminRoute && !!warning.duplicateRoutes && _react2.default.createElement(
          'div',
          null,
          warning.duplicateRoutes,
          (0, _editor.createEditorElement)("routes", slots, contentModel, this.viewStore, { registeredAuthStrategies: registeredAuthStrategies, onSave: function onSave() {
              return editorViewStore.stopEditing();
            } })
        )
      );

      if (!options.insideEditor) return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_collectionGridEditor2.default, { currentView: currentView, contentModel: contentModel }),
        _react2.default.createElement(
          'div',
          { className: 'editable-group' },
          _react2.default.createElement(
            'button',
            { className: 'btn red delete-b', onClick: deleteAllEntities },
            'DELETE ALL ENTITIES'
          )
        )
      );

      return _react2.default.createElement(_editor2.default, this.props);
    }
  }]);
  return ConfigurationEditor;
}(_baseComponent2.default), _class2.ViewStore = (_dec = _mobx.action.bound, (_class3 = function (_BaseViewStore) {
  (0, _inherits3.default)(ConfigurationViewStore, _BaseViewStore);

  function ConfigurationViewStore() {
    (0, _classCallCheck3.default)(this, ConfigurationViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationViewStore.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfigurationViewStore, [{
    key: 'deleteAllEntities',
    value: function deleteAllEntities(e) {
      if (confirm("This will permanently delete all entities, are you sure?")) {
        var contentModel = this.props.contentModel;

        contentModel.$parent.deleteAllEntities(function () {
          return window.location.reload();
        });
      }
    }
  }]);
  return ConfigurationViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class3.prototype, 'deleteAllEntities', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'deleteAllEntities'), _class3.prototype)), _class3)), _temp)) || _class) || _class;

exports.default = ConfigurationEditor;

var RouteEditor = exports.RouteEditor = (0, _simboxEditable.Decorator)(_class4 = (0, _mobxReact.observer)(_class4 = (_temp2 = _class5 = function (_BaseComponent2) {
  (0, _inherits3.default)(RouteEditor, _BaseComponent2);

  function RouteEditor() {
    (0, _classCallCheck3.default)(this, RouteEditor);
    return (0, _possibleConstructorReturn3.default)(this, (RouteEditor.__proto__ || (0, _getPrototypeOf2.default)(RouteEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(RouteEditor, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          options = _props2.options,
          contentModel = _props2.contentModel,
          _props2$contentModel = _props2.contentModel,
          registeredAuthStrategies = _props2$contentModel.registeredAuthStrategies,
          isNew = _props2$contentModel.isNew,
          isDirty = _props2$contentModel.isDirty,
          updateValue = _props2$contentModel.updateValue,
          invalid = _props2$contentModel.invalid,
          authStrategy = _props2$contentModel.authStrategy,
          authStrategyType = _props2$contentModel.authStrategyType,
          allCms = _props2$contentModel.allCms,
          id = _props2$contentModel.id,
          authStrategyDescription = _props2$contentModel.authStrategyDescription,
          availableDestinations = _props2$contentModel.availableDestinations,
          slots = _props2$contentModel.slots;
      var _viewStore = this.viewStore,
          selectAuthStrategy = _viewStore.selectAuthStrategy,
          confirmAuthStrategy = _viewStore.confirmAuthStrategy,
          confirmedAuthStrategy = _viewStore.confirmedAuthStrategy,
          saveRoute = _viewStore.saveRoute,
          SelectedView = _viewStore.SelectedView,
          isRoot = _viewStore.isRoot,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs;


      return _react2.default.createElement(
        'div',
        null,
        isRoot && _react2.default.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        !!SelectedView ? _react2.default.createElement(SelectedView, null) // there is a sub-view, just edit THAT
        : confirmedAuthStrategy ? // auth strategy has been confirmed
        _react2.default.createElement(
          'div',
          null,
          (0, _editor.createEditorElement)("roles", slots, contentModel, this.viewStore, { hideInMenu: "create" }),
          (0, _editor.createEditorElement)("urlmatch", slots, contentModel),
          (0, _editor.createEditorElement)("destinations", slots, contentModel, this.viewStore, { hideInMenu: "edit" }),
          _react2.default.createElement(_editor2.default, { contentModel: authStrategy, showButtons: false, options: options, insideEditor: options.insideEditor }),
          _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'button',
              { disabled: (0, _keys2.default)(invalid).length || !isDirty && !authStrategy.isDirty || invalid.authStrategy, onClick: saveRoute },
              'Save'
            ),
            _react2.default.createElement(
              'button',
              { disabled: !isDirty && !authStrategy.isDirty, onClick: function onClick(e) {
                  contentModel.revert(), authStrategy.revert();
                } },
              'Cancel'
            )
          )
        ) : // initial view 
        _react2.default.createElement(
          'div',
          null,
          (0, _editor.createEditorElement)("id", slots, contentModel),
          !!invalid.authStrategyType && _react2.default.createElement(
            'div',
            { className: 'errorMessage' },
            invalid.authStrategyType
          ),
          _react2.default.createElement(
            'select',
            { onChange: selectAuthStrategy },
            _react2.default.createElement('option', null),
            registeredAuthStrategies.map(function (a) {
              return _react2.default.createElement(
                'option',
                { value: a.id, key: a.id },
                a.id
              );
            })
          ),
          !!authStrategyDescription && _react2.default.createElement(
            'div',
            null,
            authStrategyDescription
          ),
          _react2.default.createElement(
            'button',
            { disabled: !authStrategyType, onClick: function onClick(e) {
                return confirmAuthStrategy();
              } },
            'Confirm Auth Strategy'
          )
        )
      );
    }
  }]);
  return RouteEditor;
}(_baseComponent2.default), _class5.ViewStore = (_dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class6 = function (_EditorViewStore) {
  (0, _inherits3.default)(RouteEditorViewStore, _EditorViewStore);

  function RouteEditorViewStore() {
    (0, _classCallCheck3.default)(this, RouteEditorViewStore);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (RouteEditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(RouteEditorViewStore)).apply(this, arguments));

    _initDefineProp(_this4, 'confirmedAuthStrategy', _descriptor, _this4);

    var cm = _this4.props.contentModel;

    if (cm.authStrategy && !cm.authStrategy.isNew) _this4.confirmedAuthStrategy = true;

    _this4.dispose = (0, _mobx.reaction)(function () {
      return cm.id;
    }, function () {
      return cm.authStrategy && (cm.authStrategy.id = cm.id + "_authStrategy");
    });
    return _this4;
  }

  (0, _createClass3.default)(RouteEditorViewStore, [{
    key: 'selectAuthStrategy',
    value: function selectAuthStrategy(e) {
      var cm = this.props.contentModel;

      cm.updateValue("authStrategyType", e.target.value ? cm.registeredAuthStrategies.find(function (a) {
        return a.id === e.target.value;
      }) : null);
      if (e.target.value) {
        cm.createAuthStrategy();
      }
    }
  }, {
    key: 'confirmAuthStrategy',
    value: function confirmAuthStrategy() {
      var cm = this.props.contentModel;

      cm.authStrategy.saveEntity();
      cm.saveEntity();
      this.confirmedAuthStrategy = true;
    }
  }, {
    key: 'saveRoute',
    value: function saveRoute() {
      var _props3 = this.props,
          contentModel = _props3.contentModel,
          _props3$contentModel = _props3.contentModel,
          registeredAuthStrategies = _props3$contentModel.registeredAuthStrategies,
          authStrategy = _props3$contentModel.authStrategy,
          onSave = _props3.options.onSave;


      contentModel.saveEntity();
      authStrategy.saveEntity(function () {
        return typeof onSave === "function" && onSave(contentModel);
      });
    }
  }]);
  return RouteEditorViewStore;
}(_editor.EditorViewStore), (_descriptor = _applyDecoratedDescriptor(_class6.prototype, 'confirmedAuthStrategy', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class6.prototype, 'selectAuthStrategy', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, 'selectAuthStrategy'), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, 'confirmAuthStrategy', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, 'confirmAuthStrategy'), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, 'saveRoute', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, 'saveRoute'), _class6.prototype)), _class6)), _temp2)) || _class4) || _class4;

;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ConfigurationEditor, 'ConfigurationEditor', 'src/entity_modules/configuration-entity/editor.js');

  __REACT_HOT_LOADER__.register(RouteEditor, 'RouteEditor', 'src/entity_modules/configuration-entity/editor.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/configuration-entity/editor.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/editor.js
// module chunks = 0